import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import qs from 'qs';
import moment from 'moment';

import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
import withTheme from '@material-ui/core/styles/withTheme';
import RootRef from '@material-ui/core/RootRef';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';

import { reduxForm, formValueSelector, change as changeForm } from 'redux-form';

import IconButton from 'components/common/IconButton';
import IconMagnifier from 'components/icons/IconMagnifier';
import IconCross from 'components/icons/IconCross';
import IconRefresh from 'components/icons/IconRefresh';
import IconStar from 'components/icons/IconStar';
import IconStarOutline from 'components/icons/IconStarOutline';
import IconFilter from 'components/icons/IconFilter';

import orderLineTypes from 'config/orderLineTypes';
import dateFormat from 'config/dateFormat';

import { updateUser } from 'redux/modules/users';

import OrdersFilterParameters from './OrdersFilterParameters';
import OrdersFilterSearch from './OrdersFilterSearch';
import OrdersFilterExpansionSummary from './OrdersFilterExpansionSummary';
import OrdersFilterExpansionDetails from './OrdersFilterExpansionDetails';

const styles = theme => ({
  root: {
    marginBottom: 15,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 8,
      maxHeight: 'calc(100vh - 168px)',
      maxHeight: 'calc(100dvh - 168px)',
      overflowY: 'auto',
    },
  },
  rootVariantPatient: {
    [theme.breakpoints.down('sm')]: {
      maxHeight: 'calc(100vh - 253px)',
      maxHeight: 'calc(100dvh - 253px)',    
    },
  },
  gridItemShrink: {
    flexShrink: 1,
  },
  toolbar: {
    padding: 8,
  },
  toolbarVariantPatient: {
    display: 'block',
  },
  parametersForm: {
    position: 'relative',
    paddingLeft: 24,
    '&:before': {
      content: '""',
      position: 'absolute',
      display: 'block',
      width: 1,
      height: 44,
      top: '50%',
      left: 16,
      transform: 'translateY(-50%)',
      backgroundColor: theme.palette.primary.A100,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingTop: 8,
    },
  },
  parametersFormVariantPatient: {
    paddingLeft: 8,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
    '&:before': {
      display: 'none',
    },
  },
  searchForm: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% + 8px)',
    },
  },
  searchContainerVariantPatient: {
    marginBottom: 8,
    paddingRight: 8,
  },
  iconMagnifier: {
    width: 18,
    height: 18,
    color: theme.palette.secondary[650],
  },
  iconCross: {
    width: 14,
    height: 14,
  },
  iconRefresh: {
    display: 'block',
    width: 16,
    height: 16,
    margin: '0 16px 0 20px',
    color: theme.palette.secondary[650],
  },
  iconStarOutline: {
    width: 24,
    height: 24,
    color: theme.palette.secondary[650],
  },
  iconStar: {
    width: 24,
    height: 24,
    color: theme.palette.primary[500],
  },
  buttonClear: {
    marginTop: -5,
    marginBottom: -5,
  },
  buttonFilter: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  iconFilter: {
    width: 18,
    height: 18,
  },
  iconFilterActive: {
    color: theme.palette.primary[500],
  },
  gridItemCloseSearch:{
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  gridItemExpansionSummary: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

function onChange(values, dispatch, props, prevValues) {
  const {
    Status,
    Cities,
    User,
    Driver,
    Payer,
    Type,
    Filters,
    Sales,
    Referral,
    Prescriber,
    Watcher,
    ...otherValues
  } = values;
  const params = qs.parse(props.router.location.search, { ignoreQueryPrefix: true });
  if (params['date-of-creation-from'] || params['date-of-creation-to'] || params.status || params.state) {
    props.history.replace(props.location.pathname);
  }
  if (Filters
    && (!Filters.Status || Filters.Status.length === 0)
    && (!Filters.User || Filters.User.length === 0)
    && (!Filters.Driver || Filters.Driver.length === 0)
    && (!Filters.Payer || Filters.Payer.length === 0)
    && (!Filters.Type || Filters.Type.length === 0)
    && (!Filters.Sales || Filters.Sales.length === 0)
    && (!Filters.Referral || Filters.Referral.length === 0)
    && (!Filters.Prescriber || Filters.Prescriber.length === 0)
    && (!Filters.Watcher || Filters.Watcher.length === 0)
    && (!Filters['Date of Creation'] || Filters['Date of Creation'].length === 0)
    && (!Filters['Date of Service'] || Filters['Date of Service'].length === 0)
    && (!Filters['Date of Delivery'] || Filters['Date of Delivery'].length === 0)
    && (!Filters['Date of Claim Submission'] || Filters['Date of Claim Submission'].length === 0)
  ) {
    props.clearFields(false, false, 'Filters');
    props.clearFields(false, false, 'Date of Creation From');
    props.clearFields(false, false, 'Date of Creation To');
    props.clearFields(false, false, 'Date of Service From');
    props.clearFields(false, false, 'Date of Service To');
    props.clearFields(false, false, 'Date of Delivery From');
    props.clearFields(false, false, 'Date of Delivery To');
    props.clearFields(false, false, 'Date of Claim Submission From');
    props.clearFields(false, false, 'Date of Claim Submission To');
  }
  if (Status) {
    props.clearFields(false, false, 'Status');
    let newStatuses;
    if (!Filters
      || !Filters.Status) {
      newStatuses = Status;
    } else {
      newStatuses = Status.filter(newItem => Filters.Status.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newStatuses.length > 0) {
      newStatuses.forEach((newItem) => {
        props.array.push('Filters.Status', newItem);
      });
    } 
  }
  if (Watcher) {
    props.clearFields(false, false, 'Watcher');
    let newWatcher;
    if (!Filters
      || !Filters.Watcher) {
      newWatcher = Watcher;
    } else {
      newWatcher = Watcher.filter(newItem => Filters.Watcher.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newWatcher.length > 0) {

      newWatcher.forEach((newItem) => {
        props.array.push('Filters.Watcher', newItem);
      });
    }
  }
  if (User) {
    props.clearFields(false, false, 'User');
    let newUsers;
    if (!Filters
      || !Filters.User) {
      newUsers = User;
    } else {
      newUsers = User.filter(newItem => Filters.User.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newUsers.length > 0) {
      newUsers.forEach((newItem) => {
        props.array.push('Filters.User', newItem);
      });
    } 
  }
  if (Driver) {
    props.clearFields(false, false, 'Driver');
    let newDrivers;
    if (!Filters
      || !Filters.Driver) {
      newDrivers = Driver;
    } else {
      newDrivers = Driver.filter(newItem => Filters.Driver.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newDrivers.length > 0) {
      newDrivers.forEach((newItem) => {
        props.array.push('Filters.Driver', newItem);
      });
    } 
  }
  if (Payer) {
    props.clearFields(false, false, 'Payer');
    let newPayers;
    if (!Filters
      || !Filters.Payer) {
      newPayers = Payer;
    } else {
      newPayers = Payer.filter(newItem => Filters.Payer.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newPayers.length > 0) {
      newPayers.forEach((newItem) => {
        props.array.push('Filters.Payer', newItem);
      });
    } 
  }
  if (Sales) {
    props.clearFields(false, false, 'Sales');
    let newSales;
    if (!Filters
      || !Filters.Sales) {
      newSales = Sales;
    } else {
      newSales = Sales.filter(newItem => Filters.Sales.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newSales.length > 0) {
      newSales.forEach((newItem) => {
        props.array.push('Filters.Sales', newItem);
      });
    } 
  }
  if (Referral) {
    props.clearFields(false, false, 'Referral');
    let newReferral;
    if (!Filters
      || !Filters.Referral) {
      newReferral = Referral;
    } else {
      newReferral = Referral.filter(newItem => Filters.Referral.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newReferral.length > 0) {
      newReferral.forEach((newItem) => {
        props.array.push('Filters.Referral', newItem);
      });
    } 
  }
  if (Prescriber) {
    props.clearFields(false, false, 'Prescriber');
    let newPrescriber;
    if (!Filters
      || !Filters.Prescriber) {
      newPrescriber = Prescriber;
    } else {
      newPrescriber = Prescriber.filter(newItem => Filters.Prescriber.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newPrescriber.length > 0) {
      newPrescriber.forEach((newItem) => {
        props.array.push('Filters.Prescriber', newItem);
      });
    } 
  }
  if (Type) {
    props.clearFields(false, false, 'Type');
    let newTypes;
    if (!Filters
      || !Filters.Type) {
      newTypes = Type;
    } else {
      newTypes = Type.filter(newItem => Filters.Type.findIndex(currentItem =>
        currentItem.value === newItem.value) === -1);
    }
    if (newTypes.length > 0) {
      newTypes.forEach((newItem) => {
        props.array.push('Filters.Type', newItem);
      });
    } 
  }
  if (otherValues['Date of Creation From']
    && otherValues['Date of Creation To']
    && (otherValues['Date of Creation From'] !== prevValues['Date of Creation From']
    || otherValues['Date of Creation To'] !== prevValues['Date of Creation To'])) {
    const dateOfServiceRange =
      `${otherValues['Date of Creation From']}-${otherValues['Date of Creation To']}`;
    if (!Filters
      || !Filters['Date of Creation']
      || Filters['Date of Creation'].findIndex(item => item.value === dateOfServiceRange) === -1) {
      props.array.removeAll('Filters.Date of Creation');
      props.array.push('Filters.Date of Creation', {
        value: dateOfServiceRange,
        label: dateOfServiceRange,
      });
    }
  }
  if (Filters && Filters['Date of Creation'] && Filters['Date of Creation'].length === 0) {
    props.clearFields(false, false, 'Date of Creation From');
    props.clearFields(false, false, 'Date of Creation To');
  }
  if (otherValues['Date of Service From']
    && otherValues['Date of Service To']
    && (otherValues['Date of Service From'] !== prevValues['Date of Service From']
    || otherValues['Date of Service To'] !== prevValues['Date of Service To'])) {
    const dateOfServiceRange =
      `${otherValues['Date of Service From']}-${otherValues['Date of Service To']}`;
    if (!Filters
      || !Filters['Date of Service']
      || Filters['Date of Service'].findIndex(item => item.value === dateOfServiceRange) === -1) {
      props.array.removeAll('Filters.Date of Service');
      props.array.push('Filters.Date of Service', {
        value: dateOfServiceRange,
        label: dateOfServiceRange,
      });
    }
  }
  if (Filters && Filters['Date of Service'] && Filters['Date of Service'].length === 0) {
    props.clearFields(false, false, 'Date of Service From');
    props.clearFields(false, false, 'Date of Service To');
  }
  if (otherValues['Date of Delivery From']
    && otherValues['Date of Delivery To']
    && (otherValues['Date of Delivery From'] !== prevValues['Date of Delivery From']
    || otherValues['Date of Delivery To'] !== prevValues['Date of Delivery To'])) {
    const dateOfDeliveryRange =
      `${otherValues['Date of Delivery From']}-${otherValues['Date of Delivery To']}`;
    if (!Filters
      || !Filters['Date of Delivery']
      || Filters['Date of Delivery'].findIndex(item => item.value === dateOfDeliveryRange) === -1) {
      props.array.removeAll('Filters.Date of Delivery');
      props.array.push('Filters.Date of Delivery', {
        value: dateOfDeliveryRange,
        label: dateOfDeliveryRange,
      });
    }
  }
  if (Filters && Filters['Date of Delivery'] && Filters['Date of Delivery'].length === 0) {
    props.clearFields(false, false, 'Date of Delivery From');
    props.clearFields(false, false, 'Date of Delivery To');
  }
  if (otherValues['Date of Claim Submission From']
    && otherValues['Date of Claim Submission To']
    && (otherValues['Date of Claim Submission From'] !== prevValues['Date of Claim Submission From']
    || otherValues['Date of Claim Submission To'] !== prevValues['Date of Claim Submission To'])) {
    const dateOfClaimSubmissionRange =
      `${otherValues['Date of Claim Submission From']}-${otherValues['Date of Claim Submission To']}`;
    if (!Filters
      || !Filters['Date of Claim Submission']
      || Filters['Date of Claim Submission'].findIndex(item => item.value === dateOfClaimSubmissionRange) === -1) {
      props.array.removeAll('Filters.Date of Claim Submission');
      props.array.push('Filters.Date of Claim Submission', {
        value: dateOfClaimSubmissionRange,
        label: dateOfClaimSubmissionRange,
      });
    }
  }
  if (Filters && Filters['Date of Claim Submission'] && Filters['Date of Claim Submission'].length === 0) {
    props.clearFields(false, false, 'Date of Claim Submission From');
    props.clearFields(false, false, 'Date of Claim Submission To');
  }
  if (otherValues['Selected HCPC Code']) {
    const selectedHCPCCode = otherValues['Selected HCPC Code'];
    props.clearFields(false, false, 'Selected HCPC Code');
    if (!otherValues['HCPC Code']
      || otherValues['HCPC Code'].findIndex(item => item.value === selectedHCPCCode.value) === -1) {
      props.array.push('HCPC Code', selectedHCPCCode);
    }
  }
  if (otherValues['Selected City']) {
    const selectedCity = otherValues['Selected City'];
    props.clearFields(false, false, 'Selected City');
    if (!otherValues['City']
      || otherValues['City'].findIndex(item => item.value === selectedCity.value) === -1) {
      props.array.push('City', selectedCity);
    }
  }
  if (otherValues['Selected Patient']) {
    const selectedPatient = otherValues['Selected Patient'];
    props.clearFields(false, false, 'Selected Patient');
    if (!otherValues['Patients']
      || otherValues['Patients'].findIndex(item => item.value === selectedPatient.value) === -1) {
      props.array.push('Patients', selectedPatient);
    }
  }
}

function validateForm(values) {
  const errors = {};

  if (values.Type && orderLineTypes.indexOf(values.Type) === -1) {
    errors.Type = 'Invalid Type, please, select from list';
  }

  return errors;
}

class OrdersFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchView: props.initializeWithSearchView && props.width !== 'xs' && props.width !== 'sm',
      expandedView: props.filtersLength > 0,
    };

    this.onSearchButtonClick = this.onSearchButtonClick.bind(this);
    this.onSearchCancelButtonClick = this.onSearchCancelButtonClick.bind(this);
    this.onExpansionChange = this.onExpansionChange.bind(this);
  }

  componentWillMount() {
    const {
      variant,
      savedFilters,
      reset,
      change,
      router,
      form,
      history,
      location,
      actions,
      navigationFormName,
    } = this.props;
    const params = qs.parse(router.location.search, { ignoreQueryPrefix: true });
    const dateOfDeliveryFrom = params.from ? moment(params.from) : null;
    const dateOfDeliveryTo = params.to ? moment(params.to) : null;
    const dateOfCreationFrom = params['date-of-creation-from'] ? moment(params['date-of-creation-from']) : null;
    const dateOfCreationTo = params['date-of-creation-to'] ? moment(params['date-of-creation-to']) : null;
    const state = params.state ? params.state : null;
    const stateName = params['state-name'] ? params['state-name'] : null;
    const status = params.status ? params.status : null;
    const statusName = params['status-name'] ? params['status-name'] : null;
    let formKey = form.indexOf('schedule-ordersFilter') !== -1 ? 'schedule-ordersFilter' : 'workflow-ordersFilter';
    if (form.indexOf('archive') !== -1) {
      formKey = 'archive-ordersFilter';
    }
    const savedFilterValues = savedFilters ? savedFilters[formKey] : null;
    if (variant !== 'patient') {
      if (dateOfCreationFrom || dateOfCreationTo || state || status) {
        console.log(stateName);
        console.log(state);
        if (dateOfCreationFrom && dateOfCreationTo) {
          change('Date of Creation From', dateOfCreationFrom.format(dateFormat));
          change('Date of Creation To', dateOfCreationTo.format(dateFormat));
          change('Filters.Date of Creation', [{
            value: `${dateOfCreationFrom.format(dateFormat)}-${dateOfCreationTo.format(dateFormat)}`,
            label: `${dateOfCreationFrom.format(dateFormat)}-${dateOfCreationTo.format(dateFormat)}`,
          }]);
        }
        if (state) {
          ['Intake', 'Delivery', 'Billing', 'Collection', 'Paid', 'Rejected'].forEach((stateItem) => {
            actions.changeForm(navigationFormName, stateItem, false);
          });
          actions.changeForm(navigationFormName, stateName, true);
        }
        if (status) {
          change('Filters.Status', [{
            value: status,
            label: statusName,
          }]);
        }
        // history.replace(location.pathname);
      } else if (savedFilterValues) {
        reset();
        Object.keys(savedFilterValues).forEach((filterName) => {
          change(`Filters.${filterName}`, savedFilterValues[filterName]);
        });
        if (variant === 'schedule' && dateOfDeliveryFrom && dateOfDeliveryTo) {
          change('Date of Delivery From', dateOfDeliveryFrom.format(dateFormat));
          change('Date of Delivery To', dateOfDeliveryTo.format(dateFormat));
          change('Filters.Date of Delivery', [{
            value: `${dateOfDeliveryFrom.format(dateFormat)}-${dateOfDeliveryTo.format(dateFormat)}`,
            label: `${dateOfDeliveryFrom.format(dateFormat)}-${dateOfDeliveryTo.format(dateFormat)}`,
          }]);
          let filterVariant;
          if (dateOfDeliveryFrom.clone().startOf('month').isSame(dateOfDeliveryFrom)
            || dateOfDeliveryTo.clone().add(1, 'days').diff(dateOfDeliveryFrom, 'months', true) === 1) {
            filterVariant = 'month';
          }
          if (dateOfDeliveryFrom.clone().startOf('week').isSame(dateOfDeliveryFrom)
            || dateOfDeliveryTo.clone().add(1, 'days').diff(dateOfDeliveryFrom, 'weeks', true) === 1) {
            filterVariant = 'week';
          }
          if (dateOfDeliveryFrom.clone().startOf('day').isSame(dateOfDeliveryTo.clone().startOf('day'))) {
            filterVariant = 'day';
          }
          change('variant', filterVariant);
        }
        change('initialized', true);
      }
    }
  }

  componentDidMount() {
    const { onExpansionChange, variant } = this.props;
    onExpansionChange({
      expandedView: this.state.expandedView,
      expansionDetailsHeight: this.expansionDetailsRef.getBoundingClientRect().height,
      mobileFilterHeight: this.mobileRootRef.getBoundingClientRect().height,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { filtersLength } = this.props;
    let newExpandedView = this.state.expandedView;
    if (nextProps.filtersLength === 0) {
      newExpandedView = false;
    } else if (filtersLength === 0 && nextProps.filtersLength > 0) {
      newExpandedView = true;
    }
    this.setState({ expandedView: newExpandedView });
  }

  componentDidUpdate(prevProps) {
    const { filtersLength, onExpansionChange, mobileFilterExpanded } = this.props;
    if (filtersLength !== prevProps.filtersLength
      || mobileFilterExpanded !== prevProps.mobileFilterExpanded) {

      onExpansionChange({
        expandedView: this.state.expandedView,
        expansionDetailsHeight: this.expansionDetailsRef.getBoundingClientRect().height,
        mobileFilterHeight: this.mobileRootRef.getBoundingClientRect().height,
      });
    }
  }

  onSearchButtonClick() {
    this.setState({ searchView: true });
  }

  onSearchCancelButtonClick() {
    const { clearFields } = this.props;
    this.setState({ searchView: false });
    clearFields(false, false, 'Order ID');
    clearFields(false, false, 'Patients');
    clearFields(false, false, 'Patient Date of Birth');
    clearFields(false, false, 'HCPC Code');
    clearFields(false, false, 'HCPC Code Name');
    clearFields(false, false, 'Patient Insurance Code');
    clearFields(false, false, 'Claim Code');
  }

  onExpansionChange() {
    const { onExpansionChange, filtersLength, variant } = this.props;
    const newExpandedView = !this.state.expandedView;
    if (filtersLength > 0) {
      this.setState({ expandedView: newExpandedView });
    }
    onExpansionChange({
      expandedView: newExpandedView,
      expansionDetailsHeight: this.expansionDetailsRef.getBoundingClientRect().height,
      mobileFilterHeight: this.mobileRootRef.getBoundingClientRect().height,
    });
  }

  render() {
    const {
      form,
      handleSubmit,
      filtersLength,
      variant,
      selectedStatuses,
      selectedTypes,
      selectedCities,
      selectedUsers,
      selectedDrivers,
      selectedPayers,
      selectedSales,
      selectedReferralSources,
      selectedPrescribers,
      selectedHCPC,
      selectedWatcher,
      selectedPatients,
      contextFiltersOptions,
      className,
      actions,
      filterValues,
      savedFilters, 
      account,
      width,
      classes,
      mobileFilterExpanded,
      theme,
      ...otherProps
    } = this.props;
    const { searchView, expandedView } = this.state;
    let formKey = form.indexOf('schedule-ordersFilter') !== -1 ? 'schedule-ordersFilter' : 'workflow-ordersFilter';
    if (form.indexOf('archive') !== -1) {
      formKey = 'archive-ordersFilter';
    }
    const savedFilterValues = savedFilters ? savedFilters[formKey] : {};
    const compareFilterValues = Object.assign({}, filterValues);
    const compareSavedFilterValues = Object.assign({}, savedFilterValues);
    if (variant === 'schedule') {
      delete compareFilterValues['Date of Delivery'];
      delete compareSavedFilterValues['Date of Delivery'];
    }
    const savedFiltersActive = savedFilters ? isEqual(compareSavedFilterValues, compareFilterValues) : false;
    const FilterComponent = (
      <RootRef
        rootRef={(mobileRootRef) => {
          this.mobileRootRef = mobileRootRef;
        }}
      >
        <Paper
          className={classNames(classes.root, className, {
            [classes.rootVariantPatient]: variant === 'patient',
          })}
        >
          <form
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <Toolbar
              className={classNames(classes.toolbar, {
                [classes.toolbarVariantPatient]: variant === 'patient',
              })}
              disableGutters
            >
              {(variant === 'patient' && width !== 'xs' && width !== 'sm') && (
                <div className={classes.searchContainerVariantPatient}>
                  <Grid
                    container
                    justify="space-between"
                    alignItems="center"
                    wrap="nowrap"
                    spacing={0}
                  >
                    <Grid
                      item
                      xs={12}
                    >
                      <OrdersFilterSearch
                        variant={variant}
                        selectedHCPC={selectedHCPC}
                        selectedCities={selectedCities}
                        contextFiltersOptions={contextFiltersOptions}
                        {...otherProps}
                      />
                    </Grid>
                  </Grid>
                </div>
              )}
              <Grid
                container
                justify="space-between"
                alignItems="center"
                wrap="nowrap"
                spacing={0}
              >
                {variant !== 'patient' && searchView ? (
                  <Fragment>
                    <Grid className={classes.gridItemCloseSearch} item>
                      <IconButton
                        onClick={this.onSearchCancelButtonClick}
                        tooltipContent="Cancel"
                      >
                        <IconCross className={classes.iconCross} />
                      </IconButton>
                    </Grid>
                    <Grid
                      className={classes.gridItemShrink}
                      item
                      xs={12}
                    >
                      <OrdersFilterSearch
                        className={classes.searchForm}
                        variant={variant}
                        selectedHCPC={selectedHCPC}
                        selectedCities={selectedCities}
                        selectedPatients={selectedPatients}
                        contextFiltersOptions={contextFiltersOptions}
                        {...otherProps}
                      />
                    </Grid>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Grid
                      className={classes.gridItemShrink}
                      item
                      xs={12}
                    >
                      <Grid
                        container
                        justify="space-between"
                        alignItems="center"
                        wrap={width === 'xs' || width === 'sm' ? 'wrap' : 'nowrap'}
                        spacing={0}
                      >
                        {(variant !== 'patient' && width !== 'xs' && width !== 'sm') &&
                          <Grid item>
                            <IconButton
                              onClick={this.onSearchButtonClick}
                              tooltipContent={variant === 'patient'
                                ? 'Search by Order ID'
                                : 'Search by Patient Name, PRN, Date of Birth, HCPC S Code, Insurance ID or Order ID'}
                            >
                              <IconMagnifier className={classes.iconMagnifier} />
                            </IconButton>
                          </Grid>
                        }
                        {(width === 'xs' || width === 'sm') &&
                          <Grid
                            item
                            xs={12}
                          >
                            <OrdersFilterSearch
                              className={classes.searchForm}
                              variant={variant}
                              selectedHCPC={selectedHCPC}
                              selectedCities={selectedCities}
                              selectedPatients={selectedPatients}
                              contextFiltersOptions={contextFiltersOptions}
                              {...otherProps}
                            />
                          </Grid>
                        }
                        <Grid
                          className={classes.gridItemShrink}
                          item
                          xs={12}
                        >
                          <OrdersFilterParameters
                            className={classNames(classes.parametersForm, {
                              [classes.parametersFormVariantPatient]: variant === 'patient',
                            })}
                            variant={variant}
                            selectedStatuses={selectedStatuses}
                            selectedTypes={selectedTypes}
                            selectedWatcher={selectedWatcher}
                            selectedUsers={selectedUsers}
                            selectedDrivers={selectedDrivers}
                            selectedPayers={selectedPayers}
                            selectedSales={selectedSales}
                            selectedReferralSources={selectedReferralSources}
                            selectedPrescribers={selectedPrescribers}
                            contextFiltersOptions={contextFiltersOptions}
                            {...otherProps}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid className={classes.gridItemExpansionSummary} item>
                      <OrdersFilterExpansionSummary
                        expanded={expandedView}
                        onChange={this.onExpansionChange}
                        filtersLength={filtersLength}
                      />
                    </Grid>
                  </Fragment>
                )}
              </Grid>
            </Toolbar>
            <OrdersFilterExpansionDetails
              expanded={expandedView}
              variant={variant}
              form="OrdersFilterParameters"
              expansionDetailsRef={(expansionDetailsRef) => {
                this.expansionDetailsRef = expansionDetailsRef;
              }}
              prefix={(
                <Fragment>
                  <IconButton
                    className={classes.buttonClear}
                    onClick={() => {
                      otherProps.reset();
                      otherProps.change('initialized', true);
                    }}
                    disabled={otherProps.pristine}
                    tooltipContent="Clear all filters"
                    tooltipPlacement="right"
                  >
                    <IconRefresh className={classes.iconRefresh} />
                  </IconButton>
                  {variant !== 'patient' &&
                    <IconButton
                      className={classes.buttonClear}
                      onClick={() => {
                        if (savedFiltersActive) {
                          const newSavedFilters = Object.assign({}, savedFilters);
                          delete newSavedFilters[formKey];
                          actions.updateUser({
                            values: {
                              ID: account.ID,
                              'Saved Filters': Object.keys(newSavedFilters).length !== 0 ? JSON.stringify(newSavedFilters) : null,
                            },
                          });
                        } else {
                          actions.updateUser({
                            values: {
                              ID: account.ID,
                              'Saved Filters': JSON.stringify({
                                ...savedFilters,
                                ...{ [formKey]: filterValues },
                              }),
                            },
                          });
                        }
                      }}
                      disabled={otherProps.pristine}
                      tooltipContent={savedFiltersActive
                        ? 'Clear Saved Filters' : 'Save Filters'}
                      tooltipPlacement="right"
                    >
                      {savedFiltersActive
                        ? <IconStar className={classes.iconStar} />
                        : <IconStarOutline className={classes.iconStarOutline} />
                      }
                    </IconButton>
                  }
                </Fragment>
              )}
            />
          </form>
        </Paper>
      </RootRef>
    );
    return width === 'xs' || width === 'sm' ? (
      <Collapse
        in={mobileFilterExpanded}
        timeout={theme.transitions.duration.short}
      >
        {FilterComponent}
      </Collapse>
    ) : FilterComponent;
  }
}

OrdersFilter.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  array: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  clearFields: PropTypes.func.isRequired,
  filtersLength: PropTypes.number.isRequired,
  variant: PropTypes.oneOf([
    'workflow',
    'schedule',
    'patient',
  ]).isRequired,
  initialValues: PropTypes.shape({
    Filters: PropTypes.shape({
      User: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
      })),
      Driver: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
      })),
      Status: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      })),
      City: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      })),
    }),
  }),
  initializeWithSearchView: PropTypes.bool.isRequired,
  account: PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'First Name': PropTypes.string.isRequired,
    'Last Name': PropTypes.string.isRequired,
  }).isRequired,
  selectedStatuses: PropTypes.arrayOf(PropTypes.number),
  selectedTypes: PropTypes.arrayOf(PropTypes.string),
  selectedCities: PropTypes.arrayOf(PropTypes.string),
  selectedUsers: PropTypes.arrayOf(PropTypes.number),
  selectedDrivers: PropTypes.arrayOf(PropTypes.number),
  selectedPayers: PropTypes.arrayOf(PropTypes.number),
  selectedSales: PropTypes.arrayOf(PropTypes.number),
  selectedReferralSources: PropTypes.arrayOf(PropTypes.number),
  selectedPrescribers: PropTypes.arrayOf(PropTypes.number),
  selectedHCPC: PropTypes.arrayOf(PropTypes.number),
  contextFiltersOptions: PropTypes.shape({
    statuses: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    })).isRequired,
    orderLineTypes: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      count: PropTypes.number,
    })).isRequired,
  }),
  actions: PropTypes.shape({
    updateUser: PropTypes.func.isRequired,
  }).isRequired,
  filterValues: PropTypes.shape({
    status: PropTypes.func,
  }),
  classes: PropTypes.shape({
    gridItemShrink: PropTypes.string.isRequired,
    root: PropTypes.string.isRequired,
    toolbar: PropTypes.string.isRequired,
    parametersForm: PropTypes.string.isRequired,
    searchForm: PropTypes.string.isRequired,
    iconMagnifier: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
  }).isRequired,
  className: PropTypes.string,
  onExpansionChange: PropTypes.func,
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

OrdersFilter.defaultProps = {
  initialValues: null,
  selectedStatuses: [],
  selectedTypes: [],
  selectedCities: [],
  selectedUsers: [],
  selectedDrivers: [],
  selectedPayers: [],
  selectedSales: [],
  selectedReferralSources: [],
  selectedPrescribers: [],
  selectedHCPC: [],
  contextFiltersOptions: null,
  className: '',
  filterValues: {},
  onExpansionChange: () => {},
};

const mapStateToProps = (store, ownProps) => {
  const selector = formValueSelector(ownProps.form);
  const filterValues = selector(store, 'Filters');
  const orderIdValue = selector(store, 'Order ID');
  const selectedHCPC = selector(store, 'HCPC Code');
  const selectedCities = selector(store, 'City');
  const selectedPatients = selector(store, 'Patients');
  const filtersKeys = filterValues ? Object.keys(filterValues) : null;
  return {
    filtersLength: filtersKeys
      ? filtersKeys.reduce((accumulator, filtersKey) =>
        accumulator + filterValues[filtersKey].length, 0)
      : 0,
    initializeWithSearchView: ownProps.variant === 'patient'
      ? Boolean(orderIdValue)
      : Boolean(((selectedPatients && selectedPatients.length) || (selectedCities && selectedCities.length) || (selectedHCPC && selectedHCPC.length))),
    selectedStatuses: filterValues && filterValues.Status
      ? filterValues.Status.map(item => item.value) : [],
    selectedTypes: filterValues && filterValues.Type
      ? filterValues.Type.map(item => item.value) : [],
    selectedWatcher: filterValues && filterValues.Watcher
      ? filterValues.Watcher.map(item => item.value) : [],
    selectedUsers: filterValues && filterValues.User
      ? filterValues.User.map(item => item.value) : [],
    selectedDrivers: filterValues && filterValues.Driver
      ? filterValues.Driver.map(item => item.value) : [],
    selectedPayers: filterValues && filterValues.Payer
      ? filterValues.Payer.map(item => item.value) : [],
    selectedSales: filterValues && filterValues.Sales
      ? filterValues.Sales.map(item => item.value) : [],
    selectedReferralSources: filterValues && filterValues.Referral
      ? filterValues.Referral.map(item => item.value) : [],
    selectedPrescribers: filterValues && filterValues.Prescriber
    ? filterValues.Prescriber.map(item => item.value) : [],
    selectedHCPC: selectedHCPC ? selectedHCPC.map(item => item.value) : [],
    selectedCities: selectedCities ? selectedCities.map(item => item.value) : [],
    selectedPatients: selectedPatients ? selectedPatients.map(item => item.value) : [],
    account: store.account,
    savedFilters: store.account['Saved Filters'] ? JSON.parse(store.account['Saved Filters']) : null,
    router: store.router,
    filterValues,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ updateUser, changeForm }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(reduxForm({
  onSubmit: values => values,
  onChange,
  validate: validateForm,
  keepDirtyOnReinitialize: false,
  // initialValues: {
  //   Active: true,
  // },
})(
  withStyles(styles)(withWidth()(withTheme()(OrdersFilter))),
)));



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersFilter/OrdersFilter.js